import type { ILogger } from '@cian/logger';

import type { TOffersDealType } from 'shared/types/buildingOffers';

export interface ISubscribeToBuildingOffersParams {
  logger: ILogger;
  buildingId: number;
  dealType: TOffersDealType;
  email: string;
}

/**
 * Подписка на новые объявления здания. В монолите — `/ajax/subscriptions` (сохранённый поиск);
 * для карточки бэкенд делает отдельную ручку, до неё отправка не работает: пишем в лог и отклоняем,
 * чтобы форма не показала ложный успех
 */
export async function subscribeToBuildingOffers(params: ISubscribeToBuildingOffersParams): Promise<void> {
  const { logger, buildingId, dealType } = params;

  logger.warning('Подписка на объявления здания ещё не подключена к API', {
    domain: 'services/subscribeToBuildingOffers',
    buildingId,
    dealType,
  });

  throw new Error('Подписка на объявления здания ещё не подключена к API');
}
